import gql from 'graphql-tag';

export const CREATE_STATIONARY = gql`
  mutation createStationory($createStationoryInput: CreateStationoryInput!) {
    createStationory(createStationoryInput: $createStationoryInput) {
      id
      stationoryName
      stationoryCode
      price
      stock
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const UPDATE_STATIONARY = gql`
  mutation updateStationory($updateStationoryInput: UpdateStationoryInput!) {
    updateStationory(updateStationoryInput: $updateStationoryInput) {
      id
      stationoryName
      stationoryCode
      price
      stock
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const REMOVE_STATIONARY = gql`
  mutation removeStationory($id: Int!) {
    removeStationory(id: $id)
  }
`;

